import { AxiosResponse } from 'axios';
import { useAlert, useAuth, useZone } from 'core/contexts';
import {
    withHeaders,
    instance as axiosInstance,
} from 'core/util/axiosInstance';
import { getDefaultHeaders } from 'core/util/other';
import { commonShowAlert } from 'lib';
import { useQuery, UseQueryResult } from 'react-query';

const fetchServices = async (
    url: string,
    token: string
): Promise<AxiosResponse<any, any>> => {
    const headers = getDefaultHeaders(token);
    const response = await axiosInstance().get(url, withHeaders(headers));
    return response;
};

export const useServices = (): UseQueryResult<
    AxiosResponse<any, any>,
    unknown
> => {
    const { getSelectedDataZone } = useZone();
    const { getToken } = useAuth();
    const { showAlert, hideAlert, showErrorDetails } = useAlert();
    const selectedEnv = getSelectedDataZone();
    const customer = localStorage.getItem('realm');
    const enabledServicesUrl = `/directory/${customer}`;

    return useQuery(
        'enabled-services',
        async () => fetchServices(enabledServicesUrl, getToken()),
        {
            enabled: !!selectedEnv,
            onError: (error: any) => {
                const errorMessage: string =
                    error?.data?.message ??
                    'Unable to retrieve enabled services';
                commonShowAlert(
                    showAlert,
                    hideAlert,
                    'error',
                    errorMessage,
                    JSON.stringify(error?.data ?? ''),
                    showErrorDetails
                );
            },
        }
    );
};
